import { requireNativeModule, EventEmitter, } from 'expo-modules-core';
import { Platform } from 'react-native';
const ExpoApplePay = Platform.select({
    ios: () => requireNativeModule('ExpoApplePay'),
    default: () => null,
})();
export async function canMakePayments(paymentOptions) {
    return ExpoApplePay?.canMakePayments(paymentOptions) ?? Promise.reject();
}
const ExpoApplePayEventEmitter = Platform.select({
    ios: () => new EventEmitter(ExpoApplePay),
    default: () => null,
})();
var Events;
(function (Events) {
    Events["PaymentAuthorization"] = "PaymentAuthorization";
    Events["PaymentAuthorizationClosed"] = "PaymentAuthorizationClosed";
})(Events || (Events = {}));
export function addPaymentAuthorizationListener(listener) {
    if (ExpoApplePayEventEmitter) {
        return ExpoApplePayEventEmitter.addListener(Events.PaymentAuthorization, listener);
    }
    // noop Subscription
    return {
        remove() { },
    };
}
export function addPaymentAuthorizationClosedListener(listener) {
    if (ExpoApplePayEventEmitter) {
        return ExpoApplePayEventEmitter.addListener(Events.PaymentAuthorizationClosed, listener);
    }
    // noop Subscription
    return {
        remove() { },
    };
}
/**
 * Before calling this, the function `canMakePayments()`must be invoked.
 * Failing to do so will result in payment request failing due to mussing supported card networks
 */
export async function makePaymentRequest(paymentDetails) {
    return ExpoApplePay?.makePaymentRequest(paymentDetails) ?? Promise.reject();
}
export function isSupported() {
    return Platform.OS === 'ios';
}
//# sourceMappingURL=index.js.map